module.exports = __webpack_public_path__ + "static/img/icon-tit.31fb6e41.png";